export const VIP_PLATFORM = `vip_csspw`;
export const STORE_ID = '3311dfd0-17df-11ef-87e8-8534393c9b6c'; //jc书店
//export const STORE_ID = 'd0c5cf90-2c82-11ef-98cf-49cb618eddc2'; //jc1书店
